import { render } from "./ViolinPlot.vue?vue&type=template&id=62ae1842&scoped=true"
import script from "./ViolinPlot.vue?vue&type=script&lang=js"
export * from "./ViolinPlot.vue?vue&type=script&lang=js"

import "./ViolinPlot.vue?vue&type=style&index=0&id=62ae1842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ae1842"]])

export default __exports__